import Component from "./PetPlanTrackingPage";

export default Component;
